import * as React from 'react'
import {createErrorBoundary} from '@containers/error-boundary/error-boundary'

interface Props {
  readonly error: Error
  readonly errorInfo: React.ErrorInfo
  readonly silent?: boolean
  readonly onError?: (error: Error) => void
}

export const BaseErrorBoundary = (props: React.PropsWithChildren<Props>) => {
  const {error, errorInfo, children, silent, onError} = props
  if (!error) {
    return <>{children}</>
  }
  if (onError) {
    onError(error)
  }
  if (silent) {
    return <div />
  }
  return (
    <div className="error-boundary">
      <strong className="error-boundary__item">{'Error message:'}</strong>
      {error && <div className="error-boundary__item">{error.message}</div>}
      <strong className="error-boundary__item">{'\nError name:'}</strong>
      {error && <div className="error-boundary__item">{error.name}</div>}
      <strong className="error-boundary__item">{'\nError stack:'}</strong>
      {error && <div className="error-boundary__item">{error.stack}</div>}
      <strong className="error-boundary__item">
        {'\nError component stack:'}
      </strong>
      {errorInfo && (
        <div className="error-boundary__item">{errorInfo.componentStack}</div>
      )}
    </div>
  )
}

export const ErrorBoundary = createErrorBoundary(BaseErrorBoundary)
